import flatten from "lodash/flatten";
import _str from "shared/util/_str";

export const META_CONTENT = {
	siteName: "OkCupid | Free Online Dating",
	description: "OkCupid is the only dating app that knows you’re more substance than just a selfie—and it’s free! Download it today to make meaningful connections with real people.",
	thumbPath: "media/img/logos/2019/1024.png",
};

// Pages that can be accessed either logged in or logged out.
export const SHARED_ROUTES = {
	Legal: ["/legal/terms", "/legal/privacy", "/legal/cookies", "/legal/profiling", "/legal/arbitration", "/legal/safety-tips", "/legal/ccpa", "/security"],
	LegalPurchaseTerms: ["/legal/boosts", "/legal/subscription"],
	About: ["/about", "/about-us"],
	Press: ["/press"],
	Careers: ["/careers"],
};

// Add new authed paths here.
export const AUTHED_ROUTES = {
	AppInstantEvents: ["/app_instant_events"],
	Doubletake: ["/doubletake", "/home", "/stacks"],
	Discovery: ["/discovery"],
	MatchSearch: ["/match"],
	Messages: ["/messages"],
	StandaloneConversation: ["/standalone_conversation"],
	WhoLikesYou: ["/who-likes-you"],
	WhoYouLike: ["/who-you-like", "/mutual-likes"],
	Intros: ["/intros"],
	PasswordReboarding: ["/password_reboarding"],
	ProfileMain: ["/profile", "/profile/:userid"],
	ProfileQuestions: ["/profile/:userid/questions"],
	ProfilePhotos: ["/profile/:userid/photos"],
	Questions: ["/questions/ask"],
	Settings: ["/settings", "/settings/:page"],
	LostPassword: ["/lostpassword"],
	Boosts: ["/boost"],
	Payments: ["/payments"],
	Upgrade: ["/upgrade"],
	Incognito: ["/incognito"],
	Onboarding: ["/onboarding", "/onboarding/react"],
	Offboarding: ["/offboarding"],
	PhoneWall: ["/phone"],
	RealName: ["/realname"],
};

// Add new unauthed paths here.
export const UNAUTHED_ROUTES = {
	Splash: ["/", "/login", "/login-direct"],
	SplashLogin: ["/login", "/login-direct"],
	AccountReactivate: ["/l/:autologinToken", "/reactivate"],
	Signup: ["/signup", "/joinus"],
	Logout: ["/logout"],
};

export const ROUTES = {
	...SHARED_ROUTES,
	...AUTHED_ROUTES,
	...UNAUTHED_ROUTES,
};

export const SHARED_ROUTE_LIST = flatten(
	Object.values(SHARED_ROUTES),
);

export const AUTHED_ROUTE_LIST = flatten(
	Object.values(AUTHED_ROUTES),
);

export const UNAUTHED_ROUTE_LIST = flatten(
	Object.values(UNAUTHED_ROUTES),
);

export const ROUTE_LIST = flatten(
	Object.values(ROUTES),
);

export const ROUTE_TITLES = {
	Doubletake: _str("DoubleTake"),
	Discovery: _str("Discover"),
	MatchSearch: _str("Matches"),
	Messages: _str("Conversations"),
	StandaloneConversation: _str("Conversation"),
	WhoLikesYou: _str("Who Likes You"),
	WhoYouLike: _str("Who You Like"),
	Intros: _str("Intros"),
	ProfileMain: _str("Profile"),
	ProfileQuestions: _str("Profile Questions"),
	ProfilePhotos: _str("Profile Photos"),
	Settings: _str("Settings"),
	LostPassword: _str("Lost Password"),
	Boosts: _str("Get Boost"),
	Upgrade: _str("Upgrade to A-List"),
	Incognito: _str("Incognito"),
	Logout: _str("Goodbye!"),
	Splash: _str("Free Online Dating"),
	SplashLogin: _str("Free Online Dating"),
	Signup: _str("Free Online Dating"),
	Onboarding: _str("Onboarding"),
	Offboarding: _str("Before you go..."),
	Phone: _str("Secure your account"),
	RealName: _str("Add your real name"),
	About: _str("About"),
	Press: _str("Press"),
	Careers: _str("Careers"),
	Payments: _str("Purchase"),
};



// WEBPACK FOOTER //
// ./src/routers/shared/util/consts.js